import { useLocation, Redirect, Route } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";
import { useSetRecoilState } from "recoil";
import { ConfigContextProvider } from './ConfigProvider'
import { memo, useCallback, useEffect } from "react";
import { ETERNAL_REFRESH_TOKEN } from "../consts/auth";
import ConsoleUi from "./ConsoleUi";
import AppUserContainer from "./AppUserContainer";
import { alertState } from "./AlertDisplay/AlertDisplay.state";


const PrivateRoute = ({ loginPath, component: Component, ...restRouteProps }) => {
    const setAlert = useSetRecoilState(alertState)
    const location = useLocation();
    const isAuthenticated = useIsAuthenticated();

    // Clear alert messages when navigating to a different page
    useEffect(() => {
        setAlert({ type: "none", message: "" })
    }, [setAlert])

    const renderWithConfig = useCallback(
        (props) => (
          <ConfigContextProvider>
            <Component {...props} />
          </ConfigContextProvider>
        ),
        []
      );

    const renderDefault = useCallback(
        (props) => (
          <Component {...props} />
        ),
        []
      );
    
      if (!isAuthenticated() && !localStorage.getItem(ETERNAL_REFRESH_TOKEN)) {
        return (
          <Redirect
            to={{
              pathname: loginPath,
              state: {
                referrer: `${location.pathname}/${location.search}`,
              },
            }}
          />
        );
      }
    
      return (
        <AppUserContainer>
          {restRouteProps?.path?.includes(":game_id") ? (
            <Route {...restRouteProps} render={renderWithConfig} />
          ) : (
            <Route {...restRouteProps} render={renderDefault} />
          )}
          <ConsoleUi />
        </AppUserContainer>
      );
    
}

export default memo(PrivateRoute)